'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import PythonSoftwareDevelopment from '@/components/home/python-software-development';
import PythonSoftwareImage from '@/components/home/python-software-image';
import PythonServicesOffered from '@/components/home/python-services-offered';
import PythonTechnologiesTools from '@/components/home/python-technologies-tools';
import PythonIndustryWiseCases from '@/components/common/python-industry-wise-cases';
import HireProcessPythonDevelop from '@/components/technologies/hire-process-python-develop';
import WhyChooseMowebPython from '@/components/common/why-choose-moweb-python';
import PythonFAQ from '@/components/faqs/python-faq';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroPythonDevelopment = dynamic(() => import('@/components/technologies/tech-hero-python-development'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroPythonDevelopment />
            <PythonSoftwareDevelopment />
            <PythonSoftwareImage />
            <PythonServicesOffered />
            <PythonTechnologiesTools />
            <PythonIndustryWiseCases />
            <HireProcessPythonDevelop bg="bg-black" pageTitle="Our Python Development Process" />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <WhyChooseMowebPython />
            <TechnologyFaq title="FAQs" bg="bg-aiml">
                <PythonFAQ />
            </TechnologyFaq>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
